import React, { useState } from 'react';
import { FaChevronDown, FaQuestionCircle } from 'react-icons/fa';
import '../../styles/Home.css';

/**
 * Questions et réponses SEO pour featured snippets
 * @type {Array<{question: string, answer: string}>}
 */
const FAQ_ITEMS = [
  {
    question: 'StreamingBot est-il gratuit ?',
    answer:
      'StreamingBot est freemium : la version de base est gratuite (commandes chat, contrôle musique, overlays). Un abonnement à 4,99 €/mois débloque des fonctionnalités premium supplémentaires.',
  },
  {
    question: 'Comment connecter Twitch et Spotify ?',
    answer:
      'Connectez-vous avec votre compte Twitch en 1 clic via OAuth, puis liez votre compte Spotify depuis le dashboard. Les deux plateformes sont reliées automatiquement.',
  },
  {
    question: 'Quelles commandes chat sont disponibles ?',
    answer:
      "StreamingBot propose des commandes personnalisables : !song pour afficher la musique en cours et bien d'autres commandes configurables depuis le dashboard.",
  },
  {
    question: 'Puis-je contrôler la musique Spotify pendant mon stream ?',
    answer:
      "Oui. Vos viewers peuvent demander des titres, voter pour skip, et vous gardez le contrôle depuis le dashboard. L'intégration est en temps réel.",
  },
  {
    question: 'StreamingBot fonctionne-t-il avec OBS ?',
    answer:
      "Oui. StreamingBot fournit des overlays compatibles OBS (Browser Source) : queue musicale, statistiques, clips, etc. Copiez l'URL et ajoutez-la à OBS.",
  },
];

/**
 * Section FAQ de la page d'accueil
 * Structure SEO avec Schema.org FAQPage (injecté dans index.html)
 *
 * @component
 * @returns {JSX.Element} La section FAQ
 */
const HomeFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="faq-section" aria-labelledby="faq-title">
      <div className="faq-header">
        <FaQuestionCircle className="faq-header-icon" aria-hidden="true" />
        <h2 id="faq-title" className="faq-title">
          Questions fréquentes
        </h2>
        <p className="faq-subtitle">
          Tout ce que vous devez savoir sur StreamingBot
        </p>
      </div>

      <div className="faq-list" role="list">
        {FAQ_ITEMS.map((item, index) => (
          <article
            key={item.question}
            className={`faq-item ${openIndex === index ? 'faq-item-open' : ''}`}
            role="listitem"
          >
            <button
              type="button"
              className="faq-question"
              onClick={() => toggleItem(index)}
              aria-expanded={openIndex === index}
              aria-controls={`faq-answer-${index}`}
              id={`faq-question-${index}`}
            >
              <span>{item.question}</span>
              <FaChevronDown className="faq-chevron" aria-hidden="true" />
            </button>
            <div
              id={`faq-answer-${index}`}
              className="faq-answer"
              role="region"
              aria-labelledby={`faq-question-${index}`}
              hidden={openIndex !== index}
            >
              <p>{item.answer}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default HomeFAQ;
export { FAQ_ITEMS };
